import React, { Component as Cp } from "react";
/**@once*/
export default class BookHistory extends Cp{
    render() :React.ReactNode{
        return(
            <div>书籍历史</div>
        );
    }
}